import { API_URL } from "config";
import Http from "util/https";
import { ItemSearchParams, ItemSearchResponse } from "../types";

/**
 * ジョイフル用設定画面用・登録企業リスト検索API
 * @param params 商品リスト取得リクエストパラメータ
 * @returns total + managed_items[] レスポンスステータスコード
 */
export default async function productSearchApi(
  params: ItemSearchParams,
): Promise<ItemSearchResponse> {
  console.log('productSearchApi params:', params);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/joyful/item/search`;
  const res = await http.post<ItemSearchResponse>(url, params);
  console.log(res);

  return res.data;
}
